import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
const HeaderStyle = styled.header`
    width: 100%;
    position: fixed;
    bottom: 2rem;
    left: 0;
    z-index: var(--z-fixed);

    .nav{
        height: calc(var(--header-height) + .5rem);
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: var(--body-color);
        box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
        padding: 1.5rem;
        border-radius: 3rem;


        .nav__logo,
        .nav__toggle,
        .nav__close{
            color: var(--title-color);
        }

        .nav__logo{
            font-family: var(--title-font);
            font-weight: var(--font-medium);
        }
        
        .nav__toggle{
            display: flex;
            font-size: 1.25rem;
            cursor: pointer;
        }
        .nav__buttons{
            display: flex;
            align-items: center;
            column-gap: 1.5rem;

            .change-theme{
                font-size: 1.25rem;
                color: var(--title-color);
                cursor: pointer;
                transition: color 0.3s;
            }
        }
    }

    @media screen and (max-width: 1023px){
        .nav__menu{
            position: fixed;
            width: 80%;
            left: 0;
            right: 0;
            bottom: -60%;
            margin: 0 auto;
            background-color: var(--body-color);
            box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
            padding: 2rem 1.5rem 5rem;
            border-radius: 2rem;
            transition: bottom .3s;

            .nav__close{
                position: absolute;
                right: 1.5rem;
                bottom: .7rem;
                font-size: 1.5rem;
                cursor: pointer;
            }
        }

        .nav__list{
            grid-template-columns: repeat(3,max-content);
            justify-content: center;
            gap: 2rem 3rem;
        }
        
        .nav__link{
            display: flex;
            flex-direction: column;
            align-items: center;
            row-gap: 0.25rem;
            font-size: var(--smaller-font-size);
            color: var(--text-color-light);
            transition: color .3s;

            &:hover{
                color: var(--title-color);
            }
            i{
                font-size: 1.25rem;
            }
        }

        .active-link{
            color: var(--title-color);
        }


        .show_menu{
            bottom: 2rem;
        }
        
    }

    @media screen and (max-width: 340px){
        .container{
          margin-inline: 1rem;
        }
        .nav__menu{
          padding-bottom: 4rem;
          .nav__list{
            gap: 1rem 1.25rem;
          }
        }
        
    }
    @media screen and (min-width: 576px){
        .nav,.nav__menu{
            width: 380px;
        }
        .nav{
            margin: 0 auto;
        }
    }
    @media screen and (min-width: 1024px){
        top: 0;
        bottom: initial;
        /* width: 100vw; */
        background-color: var(--body-color);
        transition: .4s;

        .bg-header{
            box-shadow: 0 4px 20px hsla(207,24%,35%,0.1);
        }

        .nav{
            width: initial;
            height: calc(var(--header-height) + 1.5rem);
            /* box-shadow: none; */
            border-radius: 0;
            column-gap: 3rem;
            margin-inline: 1.5rem;
            padding: 0;
            border: none;

            .nav__link i,
            .nav__toggle,
            .nav__close{
                display: none;
            }
            .nav__menu{
                border: none;
                width: initial;
                box-shadow: none;
                margin-left: auto;
                background-color: var(--body-color);
                transition: background 0.3s;
                
                .nav__list{
                    display: flex;
                    column-gap: 3rem;
                    transition: background 0.3s;
                }
                .nav__link{
                    font-size: var(--normal-font-size);
                    color: var(--text-color-light);
                }
            }
        }
    }
    @media screen and (min-width: 1048px){
        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
        .dark-theme {
            
            box-shadow: rgba(51, 51, 53, 0.2) 0px 7px 29px 0px;
        }
        .container{
            margin-inline: auto;
        }
        .nav{
            box-shadow: none;
        }
    }
`


function Header({ menuref }) {

    const [isOpen, setIsOpen] = useState(false);
    const themeref = useRef(null);
    const [reference, setReference] = useState(null);
    const headref = useRef(null);

    const darkTheme = 'dark-theme';
    const iconTheme = 'ri-sun-line';
    const [dark, setDark] = useState(false);

    const [selectedtheme, setSelectedtheme] = useState(localStorage.getItem('selected-theme'));
    const [selectedIcon, setSelectedIcon] = useState(localStorage.getItem('selected-icon'));

    const getCurrentTheme = () => (
        document.body.classList.contains(darkTheme) ? 'dark' : 'light'
    )
    const getCurrentIcon = () => (themeref.current.classList.contains(iconTheme) ? 'ri-moon-line' : 'ri-sun-line')

    useEffect(() => {
        if (selectedtheme) {
            document.body.classList[selectedtheme === 'dark' ? 'add' : 'remove'](darkTheme);
            themeref.current.classList[selectedIcon === 'ri-moon-line' ? 'add' : 'remove'](iconTheme);

            document.body.classList.contains(darkTheme) ? setDark(true) : setDark(false);
        }

        themeref.current.addEventListener('click', () => {
            document.body.classList.toggle(darkTheme);
            themeref.current.classList.toggle(iconTheme);

            localStorage.setItem('selected-theme', getCurrentTheme());
            setSelectedtheme(getCurrentTheme());
            localStorage.setItem('selected-icon', getCurrentIcon());
            setSelectedIcon(getCurrentIcon());
        })
    }, [themeref?.current?.classList]);

    return (
        <HeaderStyle id='header' ref={headref}>
            <nav className='nav container' >
                <a href="#" className='nav__logo' >
                    𝑺𝒖𝒅𝒉𝒂𝒏𝒔𝒉𝒖
                </a>
                <div className={isOpen ? 'nav__menu show_menu' : 'nav__menu'} id="nav-menu" ref={menuref}>
                    <ul className="nav__list grid">
                        <li className="nav__item">
                            <a href="#home" className="nav__link" onClick={() => setIsOpen(false)}>
                                <i className="ri-home-5-line"></i>Home
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#skills" className="nav__link" onClick={() => setIsOpen(false)}>
                                <i className="ri-trophy-line"></i>Skills
                            </a>
                        </li>


                        <li className="nav__item">
                            <a href="#services" className="nav__link" onClick={() => setIsOpen(false)}><i className="ri-briefcase-line"></i>Services</a>
                        </li>

                        <li className="nav__item">
                            <a href="#projects" className="nav__link" onClick={() => setIsOpen(false)}>
                                <i className="ri-image-line"></i>Projects
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="#testimonials" className="nav__link" onClick={() => setIsOpen(false)}>
                                <i className="ri-book-open-line"></i>Testimonials
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="#contact" className="nav__link" onClick={() => setIsOpen(false)}>
                                <i className="ri-chat-3-line"></i>Contact
                            </a>
                        </li>
                    </ul>


                    {/* Close Button  */}
                    <div className="nav__close" id="nav-close" onClick={() => setIsOpen(false)}>
                        <i className="ri-close-line"></i>
                    </div>

                </div>
                <div className="nav__buttons">
                    {/* Theme Change Button */}
                    <i className="ri-moon-line change-theme" id="theme-button" ref={themeref}></i>


                    {/* Toggle Button  */}
                    <div className="nav__toggle" id="nav-toggle" onClick={() => setIsOpen(true)}>
                        <i className="ri-menu-4-line"></i>
                    </div>
                </div>
            </nav>
        </HeaderStyle>
    )
}

export default Header